export default {
  // Words
  appName: 'فرامت',
  appTagline: 'پنل انبار'
}
